import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import { observer } from 'mobx-react';
import { ArrowBack } from '@material-ui/icons';

import { RootStoreContext } from '../../../../context';
import { FANZONES } from '../../../../constants/apiUrls/apiUrls';
import callApi from '../../../../utils/callApi';

import Messaging from './messaging/Messaging';
import Header from './header/Header';

import './ActiveConversation.css';
import AnchorDashboardStore from '../../../../store/fragments/AnchorDashboardStore';


@observer
class ActiveConversation extends React.Component {

  static contextType = RootStoreContext;

  state = { currentAnchors: [] };

  componentDidMount() {
    this.getListOfAnchorsToTip();
    this.setAnchorFanAliases();
  }

  componentWillUnmount() {
    this.activateSidebar();
  }

  setAnchorFanAliases = () => {
    const { loggedInUser: { account: { anchor } } } = this.context;
    const isAnchor = !!anchor;
    if (!AnchorDashboardStore.fanAliases && isAnchor) {
      AnchorDashboardStore.setFanAliases(isAnchor, anchor?.id);
    }
  };

  activateSidebar = () => {
    this.context.privateMessagingStore.resetConversationSession();
    this.context.privateMessagingStore.openMobileSidebar();
  };

  getListOfAnchorsToTip = () => {
    callApi(FANZONES, 'get', {}).
      then((res) => {
        this.setState({ currentAnchors: res.data });
      });
  };

  render() {
    const display = !(isMobileOnly && this.context.privateMessagingStore.displaySidebar);

    return (
      <div
        id="private-chat-active-conversation"
        style={!display ? { display: 'none' } : null}
      >
        <button
          className="back-to-sidebar"
          onClick={this.activateSidebar}
        >
          <ArrowBack fontSize="inherit" />
          Conversations
        </button>
        <Header currentAnchors={this.state.currentAnchors} />
        <Messaging />
      </div>
    );
  }
}

export default ActiveConversation;
